import React from 'react';
import './Loader.css'; // Assure-toi d'avoir un fichier CSS pour le style du loader

const Loader = () => (
    <div className="loader-container">
        <div className="loader"></div>
    </div>
);

export default Loader;